import styles from "./Footer.module.scss";
import Logo from "../../assets/images/header/Logo.svg";

export const Footer = () => {

    const { section__footer, wrapper__footer, footer__list, footer__item, footer__button, footer_police } = styles;

    return (
        <footer className={section__footer}>
            <div className={wrapper__footer}>
                <ul className={footer__list}>
                    <li className={footer__item}>
                        <a href="#headerLogo">
                            <img src={Logo} alt="logo"
                             height='60px' width='55px'
                             />                            
                        </a>
                        </li>
                    <li className={footer__item}>
                        <a href="#about">O mnie</a>
                    </li>
                    <li className={footer__item}>
                        <a href="#projects">Portfolio</a>
                    </li>
                    <li className={footer__item}>
                        <a href="tel:+514510313">
                            <p>Zadzwoń</p>
                            <p>514-510-313</p>
                        </a>
                    </li>
                    <li className={footer__item}>                        
                        <a href="mailto:mierzejewski2you@gmail.com">
                            <button className={footer__button}>Napisz</button>
                        </a>                        
                    </li>
                </ul>
                <div className={footer_police}>
                    <p>
                        Icons and images created by 
                        <a href="https://icons8.com/" target="_blank" rel="noreferrer" > icons8</a>
                        <a href="https://unsplash.com/" target="_blank" rel="noreferrer" > ,unsplash</a>
                        <a href="https://iconscout.com/" target="_blank" rel="noreferrer" > ,iconscout</a>
                    </p>
                </div>
            </div>           
        </footer>
    )
}